import React from 'react';
function SurveyBanner(props) {
    if (!!props.show) {
        return null
    } else {
        return (

            <div className="title">
                <h1>Welcome to the interactive survey</h1>
                <p>Answer few simple questions below to get the personalized recommendations</p>
            </div>
        )
    }

}
export default SurveyBanner